module.exports = __webpack_public_path__ + "img/red-pack.d14d644f.png";